import React, { PureComponent } from 'react';
import classnames from 'classnames';
import Mediator from '../../services/Mediator';

class CardPreview extends PureComponent {
    constructor(...args) {
        super(...args);

        this.state = { stage: null };

        Mediator.add(this);
    }
    componentWillUnmount() {
        Mediator.remove(this);
    }
    onGridCellChange(stage) {
        this.setState({ stage });
    }
    render() {
        let { stage } = this.state;
        let parentClasses=classnames({
            'flipped': stage > 1,
            'visible': stage !== null,
            'visual-guide': true,
            ['column' + stage]: stage !== null
        });

        return (<div className={ parentClasses }>
            <div className="card">
                <div className="face">
                    <div className="main">&#x25b2;&#x25b2;&#x25b2;&#x25b2;</div>
                    <div className="secondary">&#x25b2;&#x25b2;&#x25b2;&#x25b2;</div>
                </div>
                <div className="face">
                    <div className="main">&#x2b24;&#x2b24;&#x2b24;&#x2b24;</div>
                    <div className="secondary">&#x2b24;&#x2b24;&#x2b24;&#x2b24;</div>
                </div>
            </div>
        </div>);
    }
}

export default CardPreview;


// WEBPACK FOOTER //
// ./src/components/cardpreview/index.js